export { default as savedCoursesEn } from './localeEn';
export { default as savedCoursesEs } from './localeEs';
export { default as savedCoursesPt } from './localePt';
